import api from "../../../components/api"
import Logger from "../../../logging/logger"
import { hasUsableDayRange, InvoiceReminderSchedule, InvoiceReminderScheduleSettings } from "./invoiceReminderSchedule"

export const getInvoiceReminderSchedule = async (): Promise<InvoiceReminderScheduleSettings> => {
  const settings = (await api.get<InvoiceReminderScheduleSettings>(`/web/invoicing/settings/reminder-schedule`)).data

  if (settings.available && !hasUsableDayRange(settings)) {
    Logger.logError(new Error('Invoice reminder schedule was returned without a usable day range'))
    throw new Error('Invoice reminder schedule is missing its allowed day range')
  }

  return settings
}

export const updateInvoiceReminderSchedule = async (schedule: InvoiceReminderSchedule): Promise<void> => {
  await api.post(`/web/invoicing/settings/reminder-schedule`, {
    enabled: schedule.enabled,
    steps: schedule.steps
  })
}
